import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "components/ui/ConfirmModal";

/**
 * ★ 2026-10-12 본인인증 필요 안내(전역) — 서버 409 IDENTITY_REQUIRED.
 *  강사·무용수는 휴대폰 본인인증만 하면 바로 부여된다. 예전 가입자(본인인증 전)가 어디서 유형을 추가하든
 *  같은 안내를 띄우고 본인인증이 있는 개인정보 관리(/profileEdit)로 보낸다.
 *  MuyeonApi 응답 인터셉터가 'muyeonIdentityRequired' 이벤트를 보낸다.
 */
export const IDENTITY_REQUIRED_EVENT = "muyeonIdentityRequired";

export default function IdentityRequiredHost() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener(IDENTITY_REQUIRED_EVENT, on);
    return () => window.removeEventListener(IDENTITY_REQUIRED_EVENT, on);
  }, []);
  return (
    <ConfirmModal
      isShow={open}
      title="본인인증이 필요해요"
      body="강사·무용수는 휴대폰 본인인증만 하면 바로 이용할 수 있어요. 개인정보 관리에서 본인인증을 먼저 해 주세요."
      cancelText="다음에"
      confirmText="본인인증 하기"
      onCancel={() => setOpen(false)}
      onConfirm={() => { setOpen(false); navigate("/profileEdit"); }}
    />
  );
}
